<template>
  <div class="headProduct"
       v-if="false">
    <div class="headProductList"
         v-show="isShowHeadProductList">
      <div class="headProductTitle">为什么值得买？您还有<span class="light">{{isCompletedNum}}</span>/<span></span>6个价值点没有了解到</div>
      <div class="headProductList_item"
           v-for="item in headProductList"
           :key="item.name">
        <div class="headProductList_icon"
             v-show="item.status"
             @click="alertProductModal(item)">
          <el-tooltip effect="dark"
                      :content="item.text"
                      placement="top">
            <img src="../assets/coin.png">
          </el-tooltip>
        </div>
        <div class="headProductList_icon"
             v-show="!item.status"
             @click="alertProductModal(item)">
          <el-tooltip effect="dark"
                      :content="item.text"
                      placement="top">
            <img src="../assets/coin2.png">
          </el-tooltip>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible"
               :show-close="false"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               custom-class="headProductListDialog"
               @open="scrollToTop"
               width="40%">
      <div class="dialogContentBox"
           ref="dialogContentBox">
        <div v-html="dialogContent"
             style="padding:20px 20px 0"></div>
        <div class="contentImg"
             style="padding:0 20px 20px">
          <img src="../assets/headProduct1.png"
               v-if="dialogVisible&&activeProduct&&activeProduct['name'] =='ner_type'">
          <img src="../assets/headProduct2.png"
               v-if="dialogVisible&&activeProduct&&activeProduct['name'] =='ner_effect'">
          <img src="../assets/headProduct3.png"
               v-if="dialogVisible&&activeProduct&&activeProduct['name'] =='Customaspect'">
        </div>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button size="small"
                   @click="cancel()">稍后再读</el-button>
        <el-button size="small"
                   type="primary"
                   :disabled="canCloseProduct"
                   @click="onRead()">{{productBtnStr}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const localS = localStorage
import { LuxonTime } from 'common'
export default {
  data() {
    return {
      isExpandHeadProductList: false,
      isShowHeadProductList: this.$store.state.user.headProductIsShow,
      isCompleted: false,
      isCompletedMove: false,
      headProductList: [],
      isCompletedNum: '6',
      defaultProductList: [
        {
          status: false,
          text: '为什么值得买：人群画像',
          name: 'CrowdPortrait',
        },
        {
          status: false,
          text: '为什么值得买：达人榜',
          name: 'TalentList',
        },
        {
          status: false,
          text: '为什么值得买：品牌榜',
          name: 'BrandList',
        },
        {
          status: false,
          text: '为什么值得买：品类发现',
          name: 'ner_type',
        },
        {
          status: false,
          text: '为什么值得买：功能功效、场景、人群等20+人货场标签分析维度',
          name: 'ner_effect',
        },
        {
          status: false,
          text: '为什么值得买：交叉分析',
          name: 'Customaspect',
        },
      ],
      textContent: {
        CrowdPortrait:
          "<div class='title'>人群画像</div><div class='contentBox'>" +
          '<h5>主要痛点</h5><p>- 品牌方在研究，往往难以全面深入地了解自己的用户和潜在用户。这时往往需要大量时间和资源来收集和分析社交媒体数据，以了解用户的兴趣、偏好、需求等方面的信息。这就难以快速作出正确的市场决策，也难以有效地开展社交媒体营销活动</p><p>- 如何快速准确地了解社交媒体用户的兴趣和需求，以便更好地制定营销策略和推广方案，提高营销效果和ROI</p>' +
          '<h5>解决方案</h5><p>社交聆听的人群画像模块通过对社交媒体数据的分析，可以为用户提供全面、深入的用户画像分析服务。该功能可以将用户数据按照性别、年龄、地域、兴趣爱好等多维度进行分类和分析，为用户提供更为全面和准确的用户画像分析服务。同时，社交聆听还可以将用户数据与竞争对手数据进行对比分析，为用户提供更为深入和有针对性的市场分析服务，帮助用户快速作出正确的市场决策。</p>' +
          '<h5>价值</h5><p>通过使用社交聆听的人群画像模块，用户可以更快速、准确地了解自己的用户和潜在用户的兴趣、需求、消费习惯等方面的信息，可以更好地制定营销策略和推广方案，提高营销效果和ROI。此外，人群画像模块还可以帮助用户发现新的市场机会和潜在用户，提高企业的市场竞争力。</p></div>',
        TalentList:
          "<div class='title'>达人榜</div><div class='contentBox'>" +
          '<h5>主要痛点</h5><p>在社交媒体上，用户需要花费大量的时间和精力才能找到高质量的内容和达人，而且由于信息量庞大，很难进行有效的筛选和鉴别，特别是在通过社交媒体上的达人来推广自己的产品或服务时，如何找到真正优质的达人，成为了商业难题。</p>' +
          '<h5>解决方案</h5><p>社交聆听的达人榜模块通过多种指标，如发帖量、互动量、<strong>达人质量</strong>等等来评估达人的质量，<strong>其中达人质量使用魔镜自研AI算法进行判断。该算法通过对达人在社交媒体上的行为、话题、内容等进行全方位的数据采集和分析，从而评估其在该领域中的影响力和专业性，提供给用户真正高质量的达人信息。</strong></p>' +
          '<h5>价值</h5><p>通过达人榜模块，用户可以轻松地找到符合自己需求的优质达人，节省大量时间和精力：可以通过该模块找到真正优质的达人，提高自己在社交媒体上的曝光和推广效果。这种针对性更强、精准度更高的达人推荐，可以提高社交媒体的使用效率和推广效果，为用户带来更大的价值。</p></div>',
        BrandList:
          "<div class='title'>品牌榜</div><div class='contentBox'>" +
          '<h5>主要痛点</h5><p>社交媒体中存在大量关于品牌的信息，品牌难以了解自己在特定话题下的曝光和表现情况，也难以发现竞争对手在这些话题下的活动和表现。这种情况导致了品牌在某些关键话题下的监控和管理存在盲点，难以得到全面的市场和竞争情报。同时，品牌也难以根据这些数据做出精准的决策和行动计划。</p>' +
          '<h5>解决方案</h5><p>社交聆听品牌榜通过AI算法，对社交媒体贴文中出现的品牌进行推断，将品牌的发帖数、互动量等信息展示在一起，让品牌可以轻松地了解自己在某些话题下的曝光和表现情况，以及竞争对手的表现情况。</p>' +
          '<h5>价值</h5><p>通过品牌榜，品牌可以更好地了解市场和竞争情报，发现趋势和机会，为品牌的决策和行动计划提供有力支持。同时，品牌榜也可以帮助品牌发现自身存在的问题和改进方案，提高品牌的营销效果和竞争力。</p></div>',
        ner_type:
          "<div class='title'>品类发现</div><div class='contentBox'>" +
          '<h5>主要痛点</h5><p>品牌方需要不断开拓新的品类，以保持市场的活力和竞争力。但是如何发现新兴品类，并对其进行准确的评估和监测，一直是品牌方面临的难题。社交媒体的海量信息让品牌方很难快速准确地发现新兴的品类，如果品牌方无法快速、准确地发现新兴品类，就可能错失市场机会，影响品牌的发展。</p>' +
          '<h5>解决方案</h5><p>社交聆听的品类发现模块通过算法对贴文中可能出现的品类词进行推断，展示各个品类词的基本信息如各个品类词的声量统计等。这个功能可以帮助品牌方快速准确地发现新兴品类，并对其进行评估和监测。具体来说，品类发现模块可以通过以下方式搞定这个难题：</p>' +
          '<p>- 自动分析社交媒体中的大量信息，发现潜在的品类；</p>' +
          '<p>- 帮助品牌方了解市场上的各个品类的声量、关注度、趋势等；</p>' +
          '<h5>价值</h5><p>- 帮助品牌方快速准确地发现新兴品类，掌握市场趋势，保持市场敏锐度；</p>' +
          '<p>- 降低品牌方的市场开拓成本，提高品牌方的市场响应速度和市场竞争力；</p>' +
          '<p>- 提供品类相关的信息，帮助品牌方更好地了解市场和受众，制定更准确的市场营销策略；</p>' +
          '<p>- 为品牌方提供对市场竞争对手的洞察</p>' +
          '<h5>案例</h5><p>在21年末爆火的话题“围炉煮茶”中，就可以借助品类发现模块发现相关的新型、爆火品类做专项研究：</p></div>',
        ner_effect:
          "<div class='title'>功能功效、场景、人群等20+人货场标签分析维度</div><div class='contentBox'>" +
          '<h5>主要痛点</h5><p>品牌方需要了解市场和消费者的需求，而社交媒体上的海量贴文中包含了大量有价值的信息。然而，品牌方在处理这些信息时常常面临如下问题</p>' +
          '<p>- 信息量过大：社交媒体上的信息量非常大，品牌方难以处理所有的信息。</p>' +
          '<p>- 信息质量参差不齐：社交媒体上的贴文涉及各种主题，很多贴文不是与新品研发相关的。</p>' +
          '<p>- 关键信息难以识别：社交媒体上的信息不规范，包含大量口语化表述和缩写词，品牌方需要花费大量时间和精力才能识别出有用的信息。</p>' +
          '<h5>解决方案</h5><p>为了解决这些问题，社交聆听提供了详细具体的20+人货场标签分析维度。具体来说，社交聆听使用AI算法对社交媒体上的贴文进行分析，识别其中可能出现的功能功效、场景、人群等标签。然后抽取出各个标签下的关键词，展示它们的基本信息，如出现次数和情感极性等。</p>' +
          '<p>通过标签分析功能，品牌方可以快速了解社交媒体上与他们感兴趣的主题相关的信息。与传统的信息收集方法相比，标签分析功能具有以下优势：</p>' +
          '<p>- 信息过滤更加精准：标签分析功能可以对社交媒体上的贴文进行分类，筛选出用户想要具体了解的标签，减少信息量过大的问题。</p>' +
          '<p>- 信息质量更高：标签分析功能可以对社交媒体上的贴文进行分析，抽取出关键词，提高信息的质量和准确性。</p>' +
          '<p>- 信息处理更加高效：标签分析功能可以快速识别出与品牌方感兴趣的主题相关的信息，帮助品牌方更快地了解市场和消费者的需求。</p>' +
          '<h5>价值</h5><p>对品牌方而言，这种标签化处理可以帮助他们更快速准确地了解贴文内容和信息，提高了用户的使用体验。通过标签分析功能，品牌方可以快速了解社交媒体上与他们感兴趣的主题相关的信息，了解市场和消费者的需求并且更加精准的定位产品。</p>' +
          '<h5>案例</h5><p>对头发护理行业进行深入分析，对社媒上高频提及的场景进行研究：</p></div>',
        Customaspect:
          "<div class='title'>交叉分析</div><div class='contentBox'>" +
          '<h5>主要痛点</h5><p>在社交媒体上进行调研时，常常需要对海量的信息进行筛选、分类、分析。传统的方式往往只能从一个维度或者有限的维度出发进行分析，无法全面准确地把握消费者的需求、喜好、行为等信息。用户需要一种更加高效、全面的方式来获取并分析这些信息，以便更好地了解消费者和市场。</p>' +
          '<h5>解决方案</h5><p>社交聆听通过交叉分析功能，可以对将平台、时间、20+人货场标签、品牌、发帖人（消费者还是KOL）进行交叉选择，实现了从多个维度同时进行分析的能力，用户可以轻松地获取多个维度的数据，进行全面深入的分析。</p>' +
          '<h5>价值</h5><p>通过交叉分析功能，用户可以更加全面准确地了解消费者的需求、喜好、行为等信息，从而更好地开展市场调研、制定营销策略，此外，还可以提升用户的工作效率，让用户更加轻松高效地完成市场调研工作。</p>' +
          '<h5>案例</h5><p>我想调查猫粮下，卫仕品牌在原料材质为冻干下消费者提到的功能功效，可以发现，卫仕品牌在该条件下主打的就是肠胃的功能功效</p></div>',
      },
      dialogVisible: false,
      productBtnStr: '我已了解',
      canCloseProduct: false,
      activeProduct: null,
      dialogContent: '',
      interval: null,
      counter: 3,
    }
  },
  methods: {
    scrollToTop() {
      this.$nextTick(() => {
        let ele = this.$refs.dialogContentBox
        ele.scrollTop = 0
      })
    },
    initProductList() {
      let headProductList = localStorage.getItem('SJ_HEAD_PRODUCT_LIST')
      if (headProductList) {
        this.headProductList = JSON.parse(headProductList)
        let arr = _.filter(JSON.parse(headProductList), function (o) {
          return !o.status
        })
        if (arr.length > 0) {
          this.isCompletedNum = arr.length
          this.$store.dispatch('user/changeHeadProductIsShow', true)
          this.isCompleted = false
        } else {
          this.isCompletedNum = '0'
          this.$store.dispatch('user/changeHeadProductIsShow', false)
          this.isCompletedMove = false
          this.isCompleted = true
        }
      } else {
        this.isCompletedNum = '6'
        this.headProductList = this.defaultProductList
        this.$store.dispatch('user/changeHeadProductIsShow', true)
        this.isCompleted = false
        localStorage.setItem(
          'SJ_HEAD_PRODUCT_LIST',
          JSON.stringify(this.headProductList)
        )
      }
    },
    alertProductModal(item) {
      this.$store.dispatch('user/changeActivedMnenue', '1-2')
      this.activeProduct = item
      if (!item.isShow) {
        if (item.name == 'Customaspect') {
          //因目前没有交叉分析所以不用修改ActivedTab
        } else {
          let obj = _.find(this.headProductList, function (o) {
            return o.name == item.name
          })
          if (this.$store.state.user.ActivedTab != item.name) {
            this.$store.dispatch('user/changeActivedTab', item.name)
            this.$store.dispatch('user/changeAnalyseTyp', item.name)
          }
        }
        if (this.$route.path != '/detail') {
          this.$router.push({
            name: 'detail',
            query: {
              plat: this.$store.state.user.plants
                ? this.$store.state.user.plants.join(',')
                : '',
              brand_name: this.$store.state.user.brandName
                ? this.$store.state.user.brandName.join(',')
                : '',
              start: LuxonTime.parseTime(
                this.$store.state.user.startMonth,
                '{y}-{m}'
              ),
              end: LuxonTime.parseTime(
                this.$store.state.user.endMonth,
                '{y}-{m}'
              ),
              word: this.$store.state.user.selectedKeyWards,
              kol_id: this.$store.state.user.KolId,
              cat_id: this.$store.state.user.catId,
              rule_id: this.$store.state.user.ruleId,
              cat_name: this.$store.state.user.catName,
              analyse_typ: this.$store.state.user.analyseTyp,
              r_rule_id: this.$store.state.user.routerRuleId,
              words: this.$store.state.user.words,
              r_analyse_typ: this.$store.state.user.routerAnalyseTyp,
              label_level: this.$store.state.user.labelLevel,
              aspect_type: this.$store.state.user.aspectType,
              kol_type: this.$store.state.user.kolType
                ? this.$store.state.user.kolType.join(',')
                : '',
            },
          })
        }
      }
      this.counter = 3
      let obj = this.headProductList.find((o) => o.name === item.name)
      if (!obj) {
        obj = this.headProductList.find((o) => o.name === 'ner_effect')
      }
      this.dialogContent = this.textContent[obj.name]
      this.$forceUpdate()
      if (obj.status === false) {
        this.productBtnStr = `我已了解(${this.counter}s)`
        this.canCloseProduct = true
        this.dialogVisible = true
        clearInterval(this.interval)
        this.interval = setInterval(() => {
          if (this.counter > 0) {
            this.productBtnStr = `我已了解(${this.counter}s)`
            this.counter--
          } else if (this.counter === 0) {
            this.canCloseProduct = false
            this.productBtnStr = '我已了解'
          }
        }, 1000) // 每3秒执行一次
      } else if (obj.status === true) {
        this.counter = 0
        this.canCloseProduct = false
        this.productBtnStr = '我已了解'
        this.dialogVisible = true
      }
    },
    cancel() {
      this.dialogVisible = false
      this.$store.dispatch('user/changeHeadProductActive', {
        name: this.$store.state.user.headProductActive.name,
        isshow: false,
      })
    },
    onRead() {
      let self = this
      let index = _.findIndex(this.headProductList, function (o) {
        return o.name == self.activeProduct.name
      })
      if (index !== -1) {
        this.headProductList[index].status = true
      } else {
        let index = _.findIndex(this.headProductList, function (o) {
          return o.name == 'ner_effect'
        })
        this.headProductList[index].status = true
      }
      let arr = _.filter(this.headProductList, function (o) {
        return !o.status
      })
      this.$store.dispatch('user/changeHeadProductList', this.headProductList)
      localStorage.setItem(
        'SJ_HEAD_PRODUCT_LIST',
        JSON.stringify(this.headProductList)
      )
      if (arr.length > 0) {
        this.isCompletedNum = arr.length
        this.$store.dispatch('user/changeHeadProductIsShow', true)
        this.isCompleted = false
      } else {
        this.isCompletedNum = '0'
        this.$store.dispatch('user/changeHeadProductIsShow', false)
        if (!this.isCompleted) {
          this.isCompletedMove = true
          this.$store.dispatch('user/changeHeadProductCompletedMove', true)
        }
        this.isCompleted = true
      }
      this.dialogVisible = false
      this.$store.dispatch('user/changeHeadProductActive', {
        name: this.$store.state.user.headProductActive.name,
        isshow: false,
      })
    },
  },
  watch: {
    '$store.state.user.headProductActive': {
      handler(newVal, oldVal) {
        if (newVal.isshow) {
          this.alertProductModal({ name: newVal.name, isshow: newVal.isshow })
        }
      },
      immediate: true,
    },
    '$store.state.user.headProductIsShow': {
      handler(newVal, oldVal) {
        this.isShowHeadProductList = newVal
      },
    },
  },
  created() {
    this.initProductList()
  },
}
</script>

<style scoped lang='less'>
.headProduct {
  background-color: #fff;

  .headProductList {
    width: 100%;
    display: flex;
    .headProductTitle {
      padding: 10px 20px;
      display: inline-block;
      .light {
        color: #3a63f3;
      }
    }
    .headProductList_item {
      margin-right: 10px;
      margin: 6px 20px 0;
      cursor: pointer;
    }
    .headProductList_icon {
      text-align: center;
      font-size: 12px;
      border-radius: 10px;
      img {
        width: 26px;
        height: 26px;
      }
    }
  }
  .dialogContentBox {
    height: 500px;
    overflow-y: auto;
    border-bottom: 1px solid #e5e5e5;
    /deep/ .contentBox {
      h4 {
        font-weight: 600;
      }
      h5 {
        color: #3a63f3;
      }
      strong {
        color: #000;
      }
    }
    /deep/ .contentImg {
      img {
        width: 100%;
        height: 100%;
      }
    }
    /deep/ .title {
      font-size: 18px;
      font-weight: 700;
      text-align: center;
      color: #000;
    }
  }
}
</style>
<style lang='less'>
.headProduct {
  .headProductListDialog {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}
</style>
